import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class SelectionBoxService {
	constructor(private http: HttpClient) {}

	loadTagGroups() {
		return this.http.get<any>(`${environment.url.profile}/tagGroups`);
	}
}
